module.exports = __webpack_public_path__ + "img/uk-location.9d1444a4.jpg";